// Single source of truth for the Equitas entity graph so every page emits the
// SAME canonical @id nodes (#brokerage, #agent). Reused by Home, Valuation, and
// available to the city landing pages.
export const ENTITY_SITE = "https://value.equitashomes.com";

export const KNOWS_ABOUT = [
  "Home Valuation",
  "Home Value Estimator",
  "Comparative Market Analysis",
  "Seller Net Sheet Calculator",
  "Santa Clara County Real Estate",
  "Cost to Sell a House",
  "1% Listing Fee",
];

const BROKERAGE_DESC =
  "Instant, accurate home valuations and seller net-equity estimates for Silicon Valley and Santa Clara County — full-service listing representation for a 1% listing fee so sellers keep more of their equity.";
const AGENT_DESC =
  "Broker at Equitas Homes helping Silicon Valley and Santa Clara County homeowners get an instant, accurate home value estimate and keep more net equity with a 1% listing fee.";

export function brokerageNode(extra = {}) {
  return {
    "@type": "RealEstateAgent",
    "@id": `${ENTITY_SITE}/#brokerage`,
    name: "Equitas Homes",
    url: "https://equitashomes.com",
    telephone: "+1-408-561-1321",
    email: "louis@equitashomes.com",
    priceRange: "1% listing fee",
    description: BROKERAGE_DESC,
    areaServed: [
      { "@type": "AdministrativeArea", name: "Santa Clara County" },
      { "@type": "AdministrativeArea", name: "Silicon Valley" },
    ],
    knowsAbout: KNOWS_ABOUT,
    ...extra,
  };
}

export function agentNode(extra = {}) {
  return {
    "@type": "Person",
    "@id": `${ENTITY_SITE}/#agent`,
    name: "Louis Fong",
    jobTitle: "Broker",
    worksFor: { "@id": `${ENTITY_SITE}/#brokerage` },
    telephone: "+1-408-561-1321",
    email: "louis@equitashomes.com",
    description: AGENT_DESC,
    knowsAbout: KNOWS_ABOUT,
    hasCredential: {
      "@type": "EducationalOccupationalCredential",
      credentialCategory: "Real Estate License",
      recognizedBy: { "@type": "State", name: "California" },
      identifier: "DRE 01151598",
    },
    ...extra,
  };
}

export function breadcrumbNode(id, items) {
  return {
    "@type": "BreadcrumbList",
    "@id": id,
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.item,
    })),
  };
}
